/**
 * Submit button should be isolated from other form elements based on UI design
 * It's might needed to be aligned left/center/right, but still in it's own row
 *
 * @example
 * <SubmitRow lobState={carLobState} />
 */
import * as React from "react";
import {
  UitkLayoutGrid,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import {
  StorefrontWizardRegionTypesContext,
  StorefrontWizardRegionTypes,
} from "components/flexComponents/PageLevelProviders/WizardContextProvider/StorefrontWizardRegionTypesContext";
import { OffsetGridItem } from "components/shared/OffsetGridItem/OffsetGridItem";
import { LOBState } from "src/stores/wizard/state";
import { SubmitButton } from "src/components/shared/SubmitButton/SubmitButton";

export interface SubmitRowProps {
  lobState: LOBState;
  className?: string;
}

export const SubmitRow: React.FunctionComponent<SubmitRowProps> = ({ lobState, className }) => {
  const submitGridcolumns: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 8 };
  const offsetColumn: UitkLayoutConditionalGridSpan = { medium: 3 };
  const submitColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: 2 };

  const defaultClassName = `all-b-margin-two all-t-margin-six`;

  const wizardRegionContext = React.useContext(StorefrontWizardRegionTypesContext);
  const isStorefront =
    StorefrontWizardRegionTypes.STOREFRONT_WIZARD_REGION_BEX === wizardRegionContext ||
    StorefrontWizardRegionTypes.STOREFRONT_WIZARD_REGION_COMET === wizardRegionContext;

  return (
    <UitkLayoutGrid columns={submitGridcolumns} space="three" className={`${defaultClassName} ${className}`}>
      {isStorefront && <OffsetGridItem colSpan={offsetColumn} />}
      <SubmitButton lobState={lobState} colSpan={submitColSpan} />
    </UitkLayoutGrid>
  );
};
